import { usePrices } from "@/contexts/prices-provider";
import { TeamUserRolesEnum } from "@/enums/team-user-role";
import { useTranslation } from "@/hooks/useTranslation";
import { AdminUserTeamDTO, TeamBillingPriceDTO } from "@shaarp/common";
import { useEffect, useState } from "react";

export default function DataTableCellAdminUserTeamLicence({
  teams,
}: {
  teams: AdminUserTeamDTO;
}) {
  const { prices, apiFetchPrices } = usePrices();
  const { t } = useTranslation();

  const [priceSelected, setPriceSelected] = useState<TeamBillingPriceDTO>();
  useEffect(() => {
    const init = async () => {
      await apiFetchPrices();
    };
    init();
  }, []);

  useEffect(() => {
    if (teams.priceId && prices.length) {
      const price = prices.find((price) => price.id === teams.priceId);
      setPriceSelected(price);
    }
  }, [teams.priceId, prices]);

  if (
    teams.role === TeamUserRolesEnum.ADMIN ||
    teams.role === TeamUserRolesEnum.BILLING
  ) {
    return null;
  }

  return (
    <>
      {priceSelected
        ? `${priceSelected.productName} (${
            priceSelected.interval === "year"
              ? t("admin.dataTableAdminTeamUsers.licence.annual")
              : t("admin.dataTableAdminTeamUsers.licence.monthly")
          })`
        : ""}
    </>
  );
}
